import { Chance } from "chance"
import { ExtractUser } from "etl/types";

const chance = new Chance();

export const extractUserFactoryMock = (howMany: number): ExtractUser[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/extract_users/${index + 1}`,
		id: index + 1,
		first_name: chance.name().split(" ")[0],
		last_name: chance.name().split(" ")[1],
		aw_id: chance.integer().toString(),
		aw_company_id: chance.integer().toString()
	}));
